module.exports = __webpack_public_path__ + "media/images/cross_small-703b30c7115fb6455c6c71d0901ddfa8.png";